import { API } from "aws-amplify";
import moment from "moment";
import dayjsTZ from "../utils/dayjs";
import dayjs from "dayjs";
import {
  requestAllPages,
  requestData,
  requestDataWithParams,
} from "../helpers/API/RequestFactory";
import axios from "axios";
import { message } from "antd";

function isWeekend(date = new Date()) {
  return date.getDay() === 6 || date.getDay() === 0;
}

export const automateRequestsToApprovals = async (userData, ipResponse) => {
  let weekendCond = isWeekend();

  if (!weekendCond) {
    const employees = await API.get("employees", "/employees").then(
      (res) => res
    );
    let applicableShifts = await API.get("shifts", "/shifts").then(
      (res) => res
    );

    const requests = await requestDataWithParams(
      "employeeRequests",
      dayjsTZ().subtract(1, "years").valueOf()
    ).then((res) => {
      if (!res || !Array.isArray(res)) {
        return [];
      }

      return res
        .filter(isApprovedRequest)
        .filter(isRequestForToday)
        .filter(isAfter10AMAndNotProcessedToday)
        .map((request) =>
          populateWithEmployeeData(request, employees, applicableShifts)
        )
        .filter(hasActiveEmployee);
    });

    if (requests?.length === 0) {
      return Promise.reject("No requests to convert");
    } else {
      return requests?.forEach(async (employeeReq) => {
        await createNewShift(employeeReq, userData, ipResponse).then(
          async (res) => {
            await markCreated(employeeReq);
          }
        );
      });
    }
  } else {
    return Promise.reject("Weekend");
  }
};

export const createNewShift = async (emplReq, userData, ipResponse) => {
  const employeeId = emplReq?.employeeId || emplReq?.employee?.employeeId;
  if (!employeeId) {
    message.error("Mungon ID e punonjesit");
    // console.log("Mungon ID e punonjesit", emplReq);
    return Promise.reject("Mungon ID e punonjesit");
  } else {
    console.log("emplReq?.shift", emplReq?.shift);
    const res = await axios.get("https://api.ipify.org/?format=json");
    const tempResp = ipResponse || {};
    tempResp.IPv4 = res?.data?.ip || "";

    let startShift = !!emplReq?.shift?.shiftStartTime
      ? dayjsTZ(emplReq?.shift?.shiftStartTime)
      : dayjsTZ().set("hour", 13).set("minute", 30);
    let endShift = !!emplReq?.shift?.shiftEndTime
      ? dayjsTZ(emplReq?.shift?.shiftEndTime)
      : dayjsTZ().set("hour", 21).set("minute", 30);

    const [s_hour, s_minute] = [startShift.hour(), startShift.minute()];
    const [e_hour, e_minute] = [endShift.hour(), endShift.minute()];

    const toSend = {
      clockInDate: dayjsTZ()
        .set("hour", s_hour)
        .set("minute", s_minute)
        .valueOf(),
      clockOutDate: dayjsTZ()
        .set("hour", e_hour)
        .set("minute", e_minute)
        .valueOf(),
      employeeId,
      clockingCategory: "manualAdmin",
      dayType: "HolidayRequest",
      clockInNote: "",
      clockOutNote: "",
      editedClockIn: false,
      editedClockOut: false,
      editedByAdmin: true,
      forgotClockOut: false,
      approved: false,
      clockingLogs: [
        {
          createdAt: dayjsTZ().valueOf(),
          note: "Krijuar në mënyrë automatike",
          newShiftByAdmin: true,
          username:
            userData?.user?.given_name + " " + userData?.user?.family_name,
          userSub: userData?.user?.userSub,
          ipResponse: tempResp || null,
        },
      ],
    };
    return await API.post("clocking", "/clocking", {
      body: {
        ...toSend,
      },
    }).then(async (res) => {
      return await markCreated(emplReq);
    });
  }
};

export const markCreated = async (emplReq) => {
  return await API.put(
    "employeeRequests",
    `/employeeRequests/${emplReq?.requestId}`,
    {
      body: {
        lastCreated: dayjsTZ().format("DD/MM/YYYY"),
      },
    }
  );
};

const isApprovedRequest = (request) => {
  return request?.requestStatus === "Aprovuar";
};

const isRequestForToday = (request) => {
  if (!request?.requestPeriod || !Array.isArray(request.requestPeriod)) {
    return false;
  }

  const todayFormatted = dayjsTZ().format("DD/MM/YYYY");
  return request.requestPeriod.some(
    (periodDate) => dayjsTZ(periodDate).format("DD/MM/YYYY") === todayFormatted
  );
};

const isAfter10AMAndNotProcessedToday = (request) => {
  const time10AM = dayjsTZ().set("hour", 10).set("minute", 0);
  const isAfter10AM = dayjsTZ().isAfter(time10AM);

  if (!isAfter10AM) {
    return false;
  }

  const lastCreated = request?.lastCreated;
  const todayFormatted = dayjsTZ().format("DD/MM/YYYY");

  if (!lastCreated) {
    return true;
  }

  // if processed today
  if (lastCreated === todayFormatted) {
    return false;
  }

  // if processed before
  return true;
};

const populateWithEmployeeData = (request, employees, applicableShifts) => {
  if (!employees || !Array.isArray(employees)) {
    return { ...request, employee: null, shift: null, employeeShift: null };
  }

  const selectedEmployee = employees.find(
    (employee) => employee?.userSub === request?.userSub
  );

  if (!selectedEmployee) {
    return { ...request, employee: null, shift: null, employeeShift: null };
  }

  const employeeShift = selectedEmployee?.employeeShiftId?.[0] || null;
  const shift =
    applicableShifts?.find((shift) => shift?.shiftId === employeeShift) || null;

  return {
    ...request,
    shift,
    employee: selectedEmployee,
    employeeShift,
  };
};

const hasActiveEmployee = (enrichedRequest) => {
  return enrichedRequest?.employee?.employeeStatus === "Aktiv";
};
